module.exports = __webpack_public_path__ + "img/search-map.64dbce66.svg";